export default "__VITE_ASSET__76878d48__"